import { EventBus } from '#shared'
import type { Message } from '#entities/message'

type ChatId = number

type RespondEventMap = Record<ChatId, (message: Message | null) => void>

export const respondEventBus = new EventBus<RespondEventMap>()
